/**
 * @file GlobalLink
 */
(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.kodakGlobalLink = {
    attach: function (context, settings) {
      if ($(".quick_link_button").length > 0) {
        $(".quick_link_button").on("click", function (e) {
          e.preventDefault();
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this)
              .parents(".global_links_outer_wrapper")
              .removeClass("active");
          } else {
            $(this).addClass("active");
            $(this).parents(".global_links_outer_wrapper").addClass("active");
          }
          return false;
        });

        $(document).on("click", function (event) {
          // Close drop down
          if (!$(event.target).closest(".global_links_outer_wrapper").length) {
            $(".quick_link_button").removeClass("active");
            $(".quick_link_button")
              .parents(".global_links_outer_wrapper")
              .removeClass("active");
          }
        });

        if (iOS()) {
          $("body").addClass("iOS-device");
        }
        function iOS() {
          return (
            [
              "iPad Simulator",
              "iPhone Simulator",
              "iPod Simulator",
              "iPad",
              "iPhone",
              "iPod",
            ].includes(navigator.platform) ||
            // iPad on iOS 13 detection
            (navigator.userAgent.includes("Mac") && "ontouchend" in document)
          );
        }
      }
    },
  };
})(jQuery, Drupal, once);
